import { render } from "./editCertificate.vue?vue&type=template&id=02be1ffa"
import script from "./editCertificate.vue?vue&type=script&lang=js"
export * from "./editCertificate.vue?vue&type=script&lang=js"

import "./editCertificate.vue?vue&type=style&index=0&id=02be1ffa&lang=less"
script.render = render

export default script